enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  REQUEST_OTP = "requestOtp",
  VERIFY_OTP = "verifyOtp",
  GET_PARTNER_BY_ID = "getPartnerById",
  FETCH_PARTNER_LIST = "FetchPartner",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_OTP = "setOtp",
  SET_OTP_ERROR = "setOtpError",
  SET_OTP_TOKEN = "setOtpToken",
  SET_WINDOW_HEIGHT = "setWindowHeight",
  SET_REPRESENT_ID = "setRepresentId",
  SET_PARTNER_VIEW_MENU = "setPartnerViewMenu",
  SET_REPRESENT_PARTNER = "setRepresentPartner",
  CLEAR_REPRESENT = "clearRepresent",
  SET_PARTNER_LIST = "setPartnerList"
}

export { Actions, Mutations };
